import { render, staticRenderFns } from "./VincularInstancias.vue?vue&type=template&id=402c05e3"
import script from "./VincularInstancias.vue?vue&type=script&lang=js"
export * from "./VincularInstancias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports